import React, { useState } from 'react';
import { createStackNavigator } from "@react-navigation/stack";
import { useTheme } from "@react-navigation/native";
import UpdatePasswordScreen  from '../../screens/SessionScreens/UpdatePasswordScreen/UpdatePasswordScreen';

const Stack = createStackNavigator();

// Stack Navigation for the login screens 

const StackNavigationResetPassword = (route) => {
    const { colors } = useTheme()

    const [api, setApi] = useState('');
 
    return (
        <>
            <Stack.Navigator
                screenOptions={{
                    headerShown: false,
                    headerTitle: '',
                    headerStyle: { backgroundColor: colors.background_header },
                    headerTintColor: colors.text_primary,
                    headerTitleStyle: { fontWeight: 'bold' },
                    headerTitleAlign: 'center',
                    headerBackButtonDisplayMode: 'minimal',
                }}
            >
              
                    <Stack.Screen name="UpdatePasswordScreen" component={UpdatePasswordScreen} />
             
            </Stack.Navigator>
        </>
    );
}

export default StackNavigationResetPassword;